import { Command } from "cmdk";
import { Dialog } from "radix-ui";
import { useState, useEffect } from "react";
import { QueryDataPage } from "./QueryDataPage";

export function CommandDialog() {
  const [open, setOpen] = useState(false);

  const [page, setPage] = useState<"root" | "query-data">("root");

  // Toggle the menu when ⌘K is pressed
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
        setPage("root");
      }
    };

    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  const commands = {
    "toggle-color-theme": {
      label: "Toggle color theme",
      action: () => {
        const theme = document.documentElement.dataset.theme;
        if (theme === "light") {
          document.documentElement.dataset.theme = "dark";
        } else {
          document.documentElement.dataset.theme = "light";
        }
        setOpen(false);
      },
    },
    "query-data": {
      label: "View Query data",
      action: () => {
        setPage("query-data");
      },
    },
  };

  return (
    <>
      <Dialog.Root open={open} onOpenChange={setOpen}>
        <Dialog.Portal>
          <Dialog.Title className="sr-only">Dev Tools</Dialog.Title>
          <Dialog.Description className="sr-only">
            Global Command Menu
          </Dialog.Description>
          <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md bg-lvl-1 shadow-lg outline-0 border border-grey-15 w-full max-w-2xl z-100">
            <Command label="Dev Tools">
              <Command.Input className="outline-0 p-2 text-grey-60 border-b border-grey-15 w-full" />
              <Command.List>
                <Command.Empty>No results found.</Command.Empty>
                <Command.Group className="p-2 body-12 text-grey-60">
                  {page === "root" &&
                    Object.entries(commands).map(([key, command]) => (
                      <Command.Item
                        key={key}
                        className="text-grey-70 p-1 body-12 rounded-md data-[selected=true]:bg-lvl-2"
                        onSelect={command.action}
                      >
                        {command.label}
                      </Command.Item>
                    ))}

                  {page === "query-data" && <QueryDataPage />}
                </Command.Group>
              </Command.List>
            </Command>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}
